import React from 'react';
import { InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-charcoal-950 text-offwhite-200 py-12 border-t border-charcoal-900" data-id="element-112">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-113">
        <div className="text-center md:text-left" data-id="element-114">
          <a href="#" className="text-2xl font-bold text-offwhite-50 tracking-tight block mb-2" data-id="element-115">
            McLean <span className="text-amber-500" data-id="element-116">PT</span>
          </a>
          <p className="text-sm text-charcoal-500" data-id="element-117">
            Physical Therapy & Performance Coaching · Camarillo, CA
          </p>
        </div>

        <div className="flex items-center space-x-6" data-id="element-118">
          <a href="https://www.instagram.com/mclean_physicaltherapy" target="_blank" rel="noopener noreferrer" className="text-charcoal-500 hover:text-amber-500 transition-colors" data-id="element-119">
            <InstagramIcon size={24} data-id="element-120" />
            <span className="sr-only" data-id="element-121">Instagram</span>
          </a>
          <a href="mailto:info@mcleanphysicaltherapy.com" className="text-charcoal-500 hover:text-amber-500 transition-colors" data-id="element-122">
            <MailIcon size={24} data-id="element-123" />
            <span className="sr-only" data-id="element-124">Email</span>
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-8 pt-8 border-t border-charcoal-900 text-center md:text-left flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-charcoal-600" data-id="element-125">
        <p data-id="element-126">
          &copy; {new Date().getFullYear()} McLean Physical Therapy. All rights
          reserved.
        </p>
        <div className="flex space-x-4" data-id="element-127">
          <a href="#" className="hover:text-offwhite-200 transition-colors" data-id="element-128">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-offwhite-200 transition-colors" data-id="element-129">
            Terms of Service
          </a>
        </div>
      </div>
    </footer>;
}